let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9FRoH")).then(() => parcelRequire('8HYwl'));